import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

export const SHARD3RDIMPORTS = [
    OwlDateTimeModule,
    OwlNativeDateTimeModule
];